import React from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import interceptor from "./petition_interceptor";

export default function petition_user(key, val, parameter) {
  const json = require("../../../../config.json");
  const urlBase = json.urlBase;
  const token = JSON.parse(localStorage.getItem("persist:demo4-auth"));

  var petition_get;
  // var urlBase = "http://api.itpscorp.com/dev/crmui";
  // var urlBase = "https://api.itpscorp.com/crmui";


  if (key === "vault-credentials") {
    // val is a pre-built query string like "?account_id=12&environment=prod"
    petition_get = urlBase + "/vault/credentials" + (val || "");
  } else if (key === "vault-facets") {
    petition_get = urlBase + "/vault/facets" + (val || "");
  } else if (key === "ssh-keys") {
    // GET /crmui/crm/profile/ssh-keys — list my SSH leases
    petition_get = urlBase + "/profile/ssh-keys" + (val || "");
  } else if (key === "vault-sonar-node-credentials") {
    // val is a sonar_node_id
    petition_get = urlBase + "/vault/sonar-nodes/" + val + "/credentials";
  } else if (key === "services") {
    petition_get = urlBase + "/services?account_id=" + val;
  } else if (key === "getCalendar") {
    petition_get = urlBase + "/calendar";
  } else if (key === "asterikQueues") {
    petition_get = urlBase + "/itpvoice/queue-servers";
  } else if (key === "invoices") {
    petition_get = urlBase + "/invoices?account_id=" + val;
  } else if (key === "invoices-all") {
    // Paginated system-wide invoices: val is a query string like "?page=1&per_page=50&status=unpaid"
    petition_get = urlBase + "/invoices/all" + (val || "");
  } else if (key === "servicesAddonNull") {
    petition_get = urlBase + "/services/" + val;
  } else if (key === "servicesAll") {
    petition_get = urlBase + "/services" + val;
  } else if (key === "assets") {
    petition_get = urlBase + "/asset-tracking" + val;
  } else if (key === "crm-asset-tracking") {
    const normalizedBase = urlBase.replace(/\/$/, "");
    petition_get = normalizedBase + "/asset-tracking" + val;
  } else if (key === "serviceAddons") {
    petition_get = urlBase + "/service-addons/" + val;
  } else if (key === "orders") {
    petition_get = urlBase + "/orders?account_id=" + val;
  } else if (key === "Allorders") {
    petition_get = urlBase + "/orders" + val;
  } else if (key === "quotes") {
    petition_get = urlBase + "/quotes?account_id=" + val;
  } else if (key === "Allquotes") {
    petition_get = urlBase + "/quotes" + val;
  } else if (key === "getAccountsInactive") {
    petition_get = urlBase + "/accounts?past_due=true&status=active" + val;
  } else if (key === "orderitems") {
    petition_get = urlBase + "/orderitems?order_id=" + val;
  } else if (key === "allorderitems") {
    petition_get = urlBase + "/orderitems" + val;
  } else if (key === "products") {
    if (val === "") {
      petition_get = urlBase + "/products";
    } else {
      petition_get = urlBase + "/products/" + val;
    }
  } else if (key === "productsSearch") {
    petition_get = urlBase + "/products" + val;
  } else if (key === "provision") {
    petition_get = urlBase + "/orderitems/" + val + "/provision";
  } else if (key === "complete") {
    petition_get = urlBase + "/orderitems/" + val + "/complete";
  } else if (key === "profile") {
    petition_get = urlBase + "/profile";
  } else if (key === "agents") {
    petition_get = urlBase + "/agents/" + val;
  } else if (key === "agentsFilter") {
    petition_get = urlBase + "/agents" + val;
  } else if (key === "agentsall") {
    petition_get = urlBase + "/agents" + val;
  } else if (key === "payments") {
    petition_get = urlBase + "/payments" + "?account_id=" + val;
  } else if (key === "account-card-setup") {
    // Card saved on a Stripe setup page (Knack accounts). val = account pk.
    petition_get = urlBase + "/accounts/" + val + "/card-setup";
  } else if (key === "ach-info") {
    // Stripe ACH saved-bank lookup. val = account_id.
    petition_get = urlBase + "/payments/ach/info?account_id=" + val;
  } else if (key === "contacts") {
    petition_get = urlBase + "/contacts?account_id=" + val;
  } else if (key === "contacts-search") {
    // Search contacts by email with optional email query parameter
    // val = accountId, parameter = email query string
    petition_get = urlBase + "/contacts?account_id=" + val + (parameter || "");
  } else if (key === "reset-password") {
    petition_get = urlBase + "/contacts/" + val + "/reset-password";
  } else if (key === "reset-password-agents") {
    petition_get = urlBase + "/agents/" + val + "/reset-password";
  } else if (key === "PDF-Invoices") {
    petition_get = urlBase + "/invoices/" + val + "/pdf";
  } else if (key === "Form477Generator") {
    petition_get = urlBase + "/service-address/generate-fcc-477";
  } else if (key === "service-address") {
    petition_get = urlBase + "/service-address?search=" + val;
  } else if (key === "service-address-only") {
    petition_get = urlBase + "/service-address";
  } else if (key === "productServices") {
    petition_get = urlBase + "/products?service_address_id=" + val;
  } else if (key === "service-address-quote") {
    petition_get = urlBase + "/service-address/" + val;
  } else if (key === "allProducts") {
    petition_get = urlBase + "/products" + val;
  } else if (key === "history") {
    petition_get =
      urlBase + "/history?account_id=" + val + "&" + "order_by=created";
  } else if (key === "quoteitems?quote_id") {
    petition_get = urlBase + "/quoteitems?quote_id=" + val;
  } else if (key === "quoteId") {
    petition_get = urlBase + "/quotes/" + val;
  } else if (key === "billingPayments") {
    petition_get =
      urlBase +
      "/dashboard/billing/payments?start_year=" +
      val.year1 +
      "&end_year=" +
      val.year2;
  } else if (key === "lateAccounts") {
    petition_get = urlBase + "/dashboard/billing/late-accounts";
  } else if (key === "product-keys") {
    petition_get = urlBase + "/product-keys" + val;
  } else if (key === "service-address-detail") {
    petition_get = urlBase + "/service-address/" + val;
  } else if (key === "refresh") {
    petition_get = urlBase + "/auth/refresh";
  } else if (key === "tickets") {
    petition_get = urlBase + "/tickets" + val;
  } else if (key === "ticket-events") {
    petition_get = urlBase + "/ticket-events?ticket_id=" + val;
  } else if (key === "contract-signing-settings") {
    // GET /crmui/crm/settings/contract-signing — one row per contract type
    petition_get = urlBase + "/settings/contract-signing";
  } else if (key === "users") {
    petition_get = urlBase + "/users" + val;
  } else if (key === "accountsall") {
    petition_get = urlBase + "/accounts" + val;
  } else if (key === "accountsall-search") {
    petition_get = urlBase + "/accounts" + val;
  } else if (key === "users-search") {
    petition_get = urlBase + "/users?unlimit=true&first_name=" + val;
  } else if (key === "user-pk") {
    petition_get = urlBase + "/users/" + val;
  } else if (key === "quotePDF") {
    petition_get = urlBase + "/quotes/" + val + "/pdf";
  } else if (key === "quoteSignedPDF") {
    petition_get = urlBase + "/quotes/" + val + "/signed-pdf";
  } else if (key === "reset-password-user") {
    petition_get = urlBase + "/users/" + val + "/reset-password";
  } else if (key === "contact_email") {
    petition_get = urlBase + "/search?contact_email=" + val;
  } else if (key === "leads") {
    petition_get = urlBase + "/leads" + val;
  } else if (key === "system-api-keys") {
    // GET /crmui/crm/system-api-keys - registry of internal caller keys (admin)
    petition_get = urlBase + "/system-api-keys" + (val || "");
  } else if (key === "system-api-keys-scopes") {
    petition_get = urlBase + "/system-api-keys/scopes";
  } else if (key === "leadsources") {
    petition_get = urlBase + "/leadsources";
  } else if (key === "lead_contacts") {
    petition_get = urlBase + "/leads/" + val + "/contacts";
  } else if (key === "leads_pk") {
    petition_get = urlBase + "/leads/" + val;
  } else if (key === "lead_notes") {
    petition_get = urlBase + "/leads/" + val + "/notes";
  } else if (key === "bids") {
    petition_get = urlBase + "/bids" + val;
  } else if (key === "bids_pk") {
    petition_get = urlBase + "/bids/" + val;
  } else if (key === "bidagencies") {
    petition_get = urlBase + "/bidagencies";
  } else if (key === "bid_notes") {
    petition_get = urlBase + "/bids/" + val + "/notes";
  } else if (key === "bid_tasks") {
    petition_get = urlBase + "/bids/" + val + "/tasks";
  } else if (key === "bid_files") {
    // GET /bids/{bid_id}/files - files uploaded to a bid, newest first
    petition_get = urlBase + "/bids/" + val + "/files";
  } else if (key === "bid_file_download") {
    // GET /bids/{bid_id}/files/{file_id}/download - binary file
    // val = { bid_id, file_id }
    petition_get = urlBase + "/bids/" + val.bid_id + "/files/" + val.file_id + "/download";
    return axios
      .get(petition_get, {
        headers: {
          Authorization: "Bearer " + token.authToken,
        },
        responseType: "blob",
      })
      .then((response) => response)
      .catch((error) => {
        console.error("API Error for", key, ":", error);
        throw error;
      });
  } else if (key === "highergov_opportunities") {
    petition_get = urlBase + "/highergov/opportunities" + val;
  } else if (key === "coustomerLookUp_account_name") {
    petition_get = urlBase + "/global-search?account_name=" + val;
  } else if (key === "coustomerLookUp_account_number") {
    petition_get = urlBase + "/global-search?account_number=" + val;
  } else if (key === "coustomerLookUp_contact_email") {
    petition_get = urlBase + "/global-search?contact_email=" + val;
  } else if (key === "coustomerLookUp_phone_number") {
    petition_get = urlBase + "/global-search?phone_number=" + val;
  } else if (key === "coustomerLookUp_phone_number_pbx") {
    petition_get = urlBase + "/global-search?pbx_number=" + val;
  } else if (key === "coustomerLookUp_service_address") {
    petition_get = urlBase + "/global-search?service_address=" + val;
  } else if (key === "coustomerLookUp_billing_api_id") {
    petition_get = urlBase + "/global-search?billing_api_id=" + val;
  } else if (key === "AgentCommissions") {
    petition_get = urlBase + "/agentcommissions?agent_id=" + val;
  } else if (key === "payouts") {
    petition_get = urlBase + "/agentpayouts?agent_id=" + val + (parameter || "");
  } else if (key === "reportAgents") {
    petition_get = urlBase + "/agents/" + val;
  } else if (key === "carriers") {
    petition_get = urlBase + "/sbc/carriers";
  } else if (key === "carriersSearch") {
    petition_get = urlBase + "/sbc/carriers" + val;
  } else if (key === "carrierIPS") {
    petition_get = urlBase + "/sbc/carrier-ips";
  } else if (key === "carrierIPSSearch") {
    petition_get = urlBase + "/sbc/carrier-ips" + val;
  } else if (key === "dids") {
    petition_get = urlBase + "/sbc/dids" + val;
  } else if (key === "didsSearch") {
    petition_get = urlBase + "/sbc/dids" + val;
  } else if (key === "rates") {
    petition_get = urlBase + "/sbc/rates" + val;
  } else if (key === "ratesSearch") {
    petition_get = urlBase + "/sbc/rates" + val;
  } else if (key === "internationalRates") {
    petition_get = urlBase + "/sbc/international-rates";
  } else if (key === "internationalRatesSearch") {
    petition_get = urlBase + "/sbc/international-rates" + val;
  } else if (key === "customerIps") {
    petition_get = urlBase + "/sbc/customer-ips" + val;
  } else if (key === "customerIpsSearch") {
    petition_get = urlBase + "/sbc/customer-ips" + val;
  } else if (key === "carrierDestinations") {
    petition_get = urlBase + "/sbc/carrier-destinations" + val;
  } else if (key === "didDestinationGroups") {
    petition_get = urlBase + "/sbc/did-destination-groups";
  } else if (key === "didDestinationGroupsSearch") {
    petition_get = urlBase + "/sbc/did-destination-groups" + val;
  } else if (key === "carrierDestinationsSearch") {
    petition_get = urlBase + "/sbc/carrier-destinations" + val;
  } else if (key === "mytickets") {
    petition_get = urlBase + "/dashboard/tickets/mytickets" + val;
  } else if (key === "ticket-blacklist") {
    petition_get = urlBase + "/ticket-blacklist" + val;
  } else if (key === "CSR") {
    petition_get = urlBase + "/accounts/" + val + "/csr";
  } else if (key === "cdr") {
    petition_get = urlBase + "/sbc/cdr" + val;
  } else if (key === "allContacts") {
    petition_get = urlBase + "/contacts" + val;
  } else if (key === "impersonate") {
    petition_get = urlBase + "/contacts/" + val + "/impersonate";
  } else if (key === "impersonateAgents") {
    petition_get = urlBase + "/agents/" + val + "/impersonate";
  } else if (key === "contactSVC") {
    petition_get = urlBase + "/contacts" + val;
  } else if (key === "ITPVoice") {
    petition_get = urlBase + "/itpvoice/app-store" + val;
  } else if (key === "ITPVoiceAppPagesPagination") {
    petition_get =
      urlBase + "/itpvoice/apps/" + val.pk + "/pages?page_name=" + val.page;
  } else if (key === "ITPVoiceAppPages") {
    petition_get = urlBase + "/itpvoice/apps/" + val.pk + "/pages";
  } else if (key === "getInvoices") {
    petition_get =
      urlBase +
      "/invoice/dashboard?start_date=" +
      val.start_date +
      "&end_date=" +
      val.end_date;
  } else if (key === "getAddress") {
    petition_get = urlBase + "/accounts/" + val.id + "/service-addresses";
  } else if (key === "healthChecks") {
    petition_get = urlBase + "/health-check";
  } else if (key === "exportDIDs") {
    petition_get = urlBase + "/export-dids";
  } else if (key === "network-locations") {
    petition_get = urlBase + val;
  } else if (key === "equipment-locations") {
    petition_get = urlBase + val;
  } else if (key === "network-devices") {
    petition_get = urlBase + val;
  } else if (key === "network-connections") {
    petition_get = urlBase + val;
  } else if (key === "auditLogs") {
    petition_get = urlBase + "/audit-logs" + val;
  } else if (key === "accountAuditLogs") {
    petition_get = urlBase + "/audit-logs/account/" + val;
  } else if (key === "audit-logs") {
    petition_get = urlBase + val;
  } else if (key === "rmm-shell-session") {
    // GET /crmui/crm/rmm/shell-sessions/<session_id>
    petition_get = urlBase + "/rmm/shell-sessions/" + val;
  } else if (key === "rmm-shell-sessions") {
    // GET /crmui/crm/rmm/shell-sessions?device_id=&user_id=&days=
    petition_get = urlBase + "/rmm/shell-sessions" + (val || "");
  } else if (key.startsWith("ticket-management/")) {
    // Handle ticket management dynamic paths
    petition_get = urlBase + "/" + key + (val ? "/" + val : "");
  } else if (key === "settings/account") {
    petition_get = urlBase + "/settings/account";
  } else if (key === "business-hours") {
    petition_get = urlBase + "/business-hours" + (val ? "/" + val : "");
  } else if (key === "kong") {
    petition_get = urlBase + "/kong" + val;
  } else if (key === "aiUsageAnalytics") {
    petition_get = urlBase + "/ai/usage/analytics" + (val || "");
  } else if (key === "aiSessionHistory") {
    petition_get = urlBase + "/ai/sessions/" + val + "/history";
  } else if (key === "saas-products") {
    // Handle both /saas-products and /saas-products/123 and /saas-products?query=params
    if (val && val.startsWith("?")) {
      petition_get = urlBase + "/saas-products" + val;
    } else {
      petition_get = urlBase + "/saas-products" + (val ? "/" + val : "");
    }
  } else if (key === "infrastructure-credentials") {
    // val is the path suffix after /infrastructure/, e.g. "42/credentials"
    petition_get = urlBase + "/infrastructure/" + val;
  } else if (key === "projects") {
    // Handle both /projects and /projects/123 and /projects?query=params
    if (val && val.startsWith("?")) {
      petition_get = urlBase + "/projects" + val;
    } else {
      petition_get = urlBase + "/projects" + (val ? "/" + val : "");
    }
  } else if (key === "master-vendors") {
    if (val && val.startsWith("?")) {
      petition_get = urlBase + "/master-vendors" + val;
    } else {
      petition_get = urlBase + "/master-vendors" + (val ? "/" + val : "");
    }
  } else if (key === "my-tasks") {
    // Handle /my-tasks and /my-tasks?query=params
    if (val && val.startsWith("?")) {
      petition_get = urlBase + "/my-tasks" + val;
    } else {
      petition_get = urlBase + "/my-tasks" + (val || "");
    }
  } else if (key === "ticket-management") {
    // Handle /ticket-management/tickets, /ticket-management/tickets/{id}, etc.
    // val format: "tickets", "tickets?status=open", "tickets/123", etc.
    petition_get = urlBase + "/ticket-management/" + val;
  } else if (key === "tech-schedules") {
    // Handle /tech-schedules, /tech-schedules/{id}, /tech-schedules?query=params
    if (val && val.startsWith("?")) {
      petition_get = urlBase + "/tech-schedules" + val;
    } else {
      petition_get = urlBase + "/tech-schedules" + (val ? "/" + val : "");
    }
  } else if (key === "tech-schedule-reminders") {
    // Handle /tech-schedules/{id}/reminders and /tech-schedules/{id}/reminders/{rid}
    // val format: "123/reminders" or "123/reminders/456"
    petition_get = urlBase + "/tech-schedules/" + val;
  } else if (key === "tech-schedules-dashboard") {
    // Handle /tech-schedules/dashboard
    petition_get = urlBase + "/tech-schedules/dashboard";
  } else if (key === "crm-tickets") {
    // Handle /crmui/crm/tickets with query params
    petition_get = urlBase + "/tickets" + (val || "");
  } else if (key === "company-holidays") {
    // Handle /company-holidays, /company-holidays/{id}, /company-holidays?year=2024
    if (val && val.startsWith("?")) {
      petition_get = urlBase + "/company-holidays" + val;
    } else {
      petition_get = urlBase + "/company-holidays" + (val ? "/" + val : "");
    }
  } else if (key === "employee-schedules") {
    // Handle /employee-schedules, /employee-schedules/{id}, /employee-schedules/{id}/approve, etc.
    if (val && val.startsWith("?")) {
      petition_get = urlBase + "/employee-schedules" + val;
    } else {
      petition_get = urlBase + "/employee-schedules" + (val ? "/" + val : "");
    }
  } else if (key === "employee-calendar") {
    // Handle /employee-calendar?start_date=X&end_date=Y
    petition_get = urlBase + "/employee-calendar" + (val || "");
  } else if (key === "inventory-search") {
    // Unified inventory search (tools, supplies, products)
    petition_get = urlBase + "/inventory/search" + (val || "");
  } else if (key === "inventory-dashboard") {
    // Inventory dashboard statistics
    petition_get = urlBase + "/inventory/dashboard";
  } else if (key === "inventory-history") {
    // Inventory transaction history/audit log
    petition_get = urlBase + "/inventory/history" + (val || "");
  } else if (key === "inventory-alerts") {
    // Get all inventory alerts
    petition_get = urlBase + "/inventory/alerts";
  } else if (key === "inventory-history") {
    // Get transaction history
    petition_get = urlBase + "/inventory/history" + (val || "");
  } else if (key === "inventory-tools") {
    // Get tools list or specific tool
    if (val) {
      petition_get = urlBase + "/inventory/tools/" + val;
    } else {
      petition_get = urlBase + "/inventory/tools" + (parameter?.query || "");
    }
  } else if (key === "inventory-tools-scan") {
    // Scan tool by QR/NFC
    petition_get = urlBase + "/inventory/tools/scan" + (val || "");
  } else if (key === "inventory-tool-checkout") {
    // Checkout a tool
    petition_get = urlBase + "/inventory/tools/" + val + "/checkout";
  } else if (key === "inventory-tool-checkin") {
    // Checkin a tool
    petition_get = urlBase + "/inventory/tools/" + val + "/checkin";
  } else if (key === "inventory-tool-maintenance") {
    // Mark tool for maintenance
    petition_get = urlBase + "/inventory/tools/" + val + "/maintenance";
  } else if (key === "inventory-supplies") {
    // Get supplies list or specific supply
    if (val) {
      petition_get = urlBase + "/inventory/supplies/" + val;
    } else {
      petition_get = urlBase + "/inventory/supplies" + (parameter?.query || "");
    }
  } else if (key === "inventory-supplies-scan") {
    // Scan supply by QR/NFC
    petition_get = urlBase + "/inventory/supplies/scan" + (val || "");
  } else if (key === "inventory-supply-adjust") {
    // Adjust supply stock
    petition_get = urlBase + "/inventory/supplies/" + val + "/adjust";
  } else if (key === "inventory-supply-restock") {
    // Restock supply
    petition_get = urlBase + "/inventory/supplies/" + val + "/restock";
  } else if (key === "inventory-supplies-low-stock") {
    // Get low stock supplies
    petition_get = urlBase + "/inventory/supplies/low-stock";
  } else if (key === "inventory-locations") {
    // Get locations list or specific location
    if (val) {
      petition_get = urlBase + "/inventory/locations/" + val;
    } else {
      petition_get = urlBase + "/inventory/locations" + (parameter?.query || "");
    }
  } else if (key === "inventory-location-items") {
    // Get all items in a location
    petition_get = urlBase + "/inventory/locations/" + val + "/items";
  } else if (key === "task-attachments") {
    petition_get = urlBase + "/tasks/" + val;
  } else if (key === "task-comments") {
    petition_get = urlBase + "/" + val;
  } else if (key === "task-customer-messages") {
    // val = "tasks/{id}/customer-messages"
    petition_get = urlBase + "/" + val;
  } else if  (key === "subtasks") {
    petition_get = urlBase + "/" + val;
  } else if (key === "task-activity") {
    petition_get = urlBase + "/" + val;
  } else if (key === "task-time-summary") {
    petition_get = urlBase + "/tasks/" + val + "/time-summary";
  } else if (key === "task-share-links") {
    petition_get = urlBase + "/" + val;
  } else if (key === "project-share-links") {
    petition_get = urlBase + "/" + val;
  } else if (key === "project-invites") {
    petition_get = urlBase + "/" + val;
  } else if (key === "share-links") {
    petition_get = urlBase + "/share-links/" + val;
  } else if (key === "tasks") {
    petition_get = urlBase + "/tasks" + val;
  } else if (key === "target-versions") {
    petition_get = urlBase + "/saas-products/versions" + val;
  } else if (key === "client-reports") {
    // Handle /accounts/{account_id}/client-reports
    petition_get = urlBase + "/accounts/" + val + "/client-reports" + (parameter || "");
  } else if (key === "client-report-sections") {
    // Handle /client-reports/sections - the report section catalog, served from
    // resources/modules/client_reports_catalog.py so the Generate Report modal
    // and the MSP quote editor cannot drift apart from the PDF templates.
    petition_get = urlBase + "/client-reports/sections";
  } else if (key === "client-report") {
    // Handle /client-reports/{report_id}
    petition_get = urlBase + "/client-reports/" + val;
  } else if (key === "client-report-pdf") {
    // Handle /client-reports/{report_id}/pdf - returns binary PDF
    petition_get = urlBase + "/client-reports/" + val + "/pdf";
    // For PDF downloads, we need responseType: 'blob'
    return axios
      .get(petition_get, {
        headers: {
          Authorization: "Bearer " + token.authToken,
        },
        responseType: 'blob',
      })
      .then((response) => response)
      .catch((error) => {
        console.error("API Error for", key, ":", error);
        throw error;
      });
  } else if (key === "service-rmm-data") {
    // Handle /services/{service_id}/rmm/data
    petition_get = urlBase + "/services/" + val + "/rmm/data";
  } else if (key === "service-rmm-sync") {
    // Handle /services/{service_id}/rmm/sync - POST
    petition_get = urlBase + "/services/" + val + "/rmm/sync";
  } else if (key === "service-rmm-test-connection") {
    // Handle /services/{service_id}/rmm/test-connection - POST
    petition_get = urlBase + "/services/" + val + "/rmm/test-connection";
  } else if (key === "service-rmm-config") {
    // Handle /services/{service_id}/rmm/config - POST
    petition_get = urlBase + "/services/" + val + "/rmm/config";
  } else if (key === "service-voice-internals") {
    petition_get = urlBase + "/services/" + val + "/voice-internals";
  } else if (key === "nable-clients") {
    // Handle /nable/clients - GET list of N-able clients
    petition_get = urlBase + "/nable/clients" + (val || "");
  } else if (key === "nable-client-sites") {
    // Handle /nable/clients/{client_id}/sites - GET sites for a client
    petition_get = urlBase + "/nable/clients/" + val + "/sites";
  } else if (key === "account-nable-mappable-assets") {
    // Handle /accounts/{account_id}/assets/nable-mappable - GET assets that can be mapped
    petition_get = urlBase + "/accounts/" + val + "/assets/nable-mappable";
  } else if (key === "asset-rmm-sync") {
    // Handle /asset-tracking/assets/{asset_id}/rmm/sync - POST to sync RMM data
    petition_get = urlBase + "/asset-tracking/assets/" + val + "/rmm/sync";
  } else if (key === "asset-rmm-map") {
    // Handle /asset-tracking/assets/{asset_id}/rmm/map - POST/DELETE to map/unmap RMM device
    petition_get = urlBase + "/asset-tracking/assets/" + val + "/rmm/map";
  } else if (key === "account-assets-rmm-sync") {
    // Handle /accounts/{account_id}/assets/rmm/sync - POST for bulk RMM sync
    petition_get = urlBase + "/accounts/" + val + "/assets/rmm/sync";
  } else if (key === "asset-patches") {
    // Handle /crmui/crm/assets/{asset_id}/patches - GET patch history for an asset
    petition_get = urlBase + "/assets/" + val + "/patches" + (parameter || "");
  } else if (key === "asset-patch-summary") {
    // Handle /crmui/crm/assets/{asset_id}/patch-summary - GET patch summary for an asset
    petition_get = urlBase + "/assets/" + val + "/patch-summary";
  } else if (key === "account-patch-report") {
    // Handle /crmui/crm/accounts/{account_id}/patch-report - GET patch report for an account
    petition_get = urlBase + "/accounts/" + val + "/patch-report" + (parameter || "");
  } else if (key === "scheduled-reminders") {
    // Handle /scheduled-reminders, /scheduled-reminders/{id}, /scheduled-reminders?query=params
    if (val && val.startsWith("?")) {
      petition_get = urlBase + "/scheduled-reminders" + val;
    } else {
      petition_get = urlBase + "/scheduled-reminders" + (val ? "/" + val : "");
    }
  } else if (key === "api-keys") {
    // Handle /api-keys - List user's API keys
    petition_get = urlBase + "/api-keys";
  } else if (key === "customer-profile") {
    // Handle /accounts/{account_id}/customer-profile
    petition_get = urlBase + "/accounts/" + val + "/customer-profile";
  } else if (key === "customer-profile-versions") {
    // Handle /accounts/{account_id}/customer-profile/versions
    petition_get = urlBase + "/accounts/" + val + "/customer-profile/versions";
  } else if (key === "expenses") {
    // Handle /expenses, /expenses/{id}, /expenses/{id}/activity, /expenses?status=Draft
    if (val && val.startsWith("?")) {
      petition_get = urlBase + "/expenses" + val;
    } else {
      petition_get = urlBase + "/expenses" + (val ? "/" + val : "");
    }
  } else if (key === "ipam-pools") {
    // GET /ipam/pools or /ipam/pools?pool_type=customer_wan
    petition_get = urlBase + "/ipam/pools" + (val || "");
  } else if (key === "ipam-pool") {
    // GET /ipam/pools/{id} - single pool with stats
    petition_get = urlBase + "/ipam/pools/" + val;
  } else if (key === "ipam-pool-addresses") {
    // GET /ipam/pools/{id}/addresses or /ipam/pools/{id}/addresses?status=available
    petition_get = urlBase + "/ipam/pools/" + val + "/addresses" + (parameter?.query || "");
  } else if (key === "ipam-pool-blocks") {
    // GET /ipam/pools/{id}/blocks or /ipam/pools/{id}/blocks?status=available
    petition_get = urlBase + "/ipam/pools/" + val + "/blocks" + (parameter?.query || "");
  } else if (key === "ipam-suggest") {
    // GET /ipam/suggest?pool_id={id}
    petition_get = urlBase + "/ipam/suggest?pool_id=" + val;
  } else if (key === "ipam-search") {
    // GET /ipam/search?q={query}
    petition_get = urlBase + "/ipam/search?q=" + encodeURIComponent(val);
  } else if (key === "ipam-account-assignments") {
    // GET /ipam/account/{account_id}/assignments?service_id=X
    petition_get = urlBase + "/ipam/account/" + val + "/assignments" + (parameter || "");

  // =========================================================================
  // Fiber / UISP Proxy Endpoints
  // =========================================================================
  } else if (key === "fiber-uisp-olts") {
    // GET /fiber/uisp/olts - List all OLTs
    petition_get = urlBase + "/fiber/uisp/olts" + (parameter?.query || "");
  } else if (key === "fiber-uisp-olt") {
    // GET /fiber/uisp/olts/{id} - Get single OLT
    petition_get = urlBase + "/fiber/uisp/olts/" + val;
  } else if (key === "fiber-uisp-olt-ports") {
    // GET /fiber/uisp/olts/{id}/ports - Get OLT PON ports
    petition_get = urlBase + "/fiber/uisp/olts/" + val + "/ports";
  } else if (key === "fiber-uisp-olt-onts") {
    // GET /fiber/uisp/olts/{id}/onts - Get ONTs connected to OLT
    petition_get = urlBase + "/fiber/uisp/olts/" + val + "/onts" + (parameter?.query || "");
  } else if (key === "fiber-uisp-onts") {
    // GET /fiber/uisp/onts - List all authorized ONTs
    petition_get = urlBase + "/fiber/uisp/onts" + (parameter?.query || "");
  } else if (key === "fiber-uisp-onts-discovered") {
    // GET /fiber/uisp/onts/discovered - List pending/unauthorized ONTs
    petition_get = urlBase + "/fiber/uisp/onts/discovered" + (parameter?.query || "");
  } else if (key === "fiber-uisp-ont") {
    // GET /fiber/uisp/onts/{id} - Get single ONT details
    petition_get = urlBase + "/fiber/uisp/onts/" + val;
  } else if (key === "fiber-uisp-ont-config") {
    // GET /fiber/uisp/onts/{id}/configuration - Get ONT config
    petition_get = urlBase + "/fiber/uisp/onts/" + val + "/configuration";
  } else if (key === "fiber-uisp-speed-profiles") {
    // GET /fiber/uisp/speed-profiles - List speed profiles
    petition_get = urlBase + "/fiber/uisp/speed-profiles";
  } else if (key === "fiber-uisp-sites") {
    // GET /fiber/uisp/sites - List UISP sites
    petition_get = urlBase + "/fiber/uisp/sites" + (parameter?.query || "");
  } else if (key === "fiber-buildings") {
    // GET /fiber/buildings - List fiber-lit buildings (from service addresses)
    petition_get = urlBase + "/fiber/buildings" + (parameter?.query || "");
  } else if (key === "deploy/servers") {
    // GET /settings/deploy/servers - List deploy servers
    petition_get = urlBase + "/settings/deploy/servers";
  } else if (key === "deployments") {
    // GET /deployments/{id} - Get deployment status
    petition_get = urlBase + "/deployments/" + val;
  } else if (key === "deployment-groups") {
    // GET /deployment-groups/{group_id} - Get rollout group status
    petition_get = urlBase + "/deployment-groups/" + val;
  } else if (key === "personal-vault") {
    // GET /personal-vault/... - Personal vault credentials
    petition_get = urlBase + "/personal-vault" + val;
  } else if (key === "m365-tenant") {
    // GET /accounts/{account_id}/m365/tenant
    petition_get = urlBase + "/accounts/" + val + "/m365/tenant";
  } else if (key === "m365-sweeps") {
    // GET /accounts/{account_id}/m365/sweeps?status=...&limit=...
    petition_get = urlBase + "/accounts/" + val + "/m365/sweeps" + (parameter || "");
  } else if (key === "m365-sweep-detail") {
    // GET /accounts/{account_id}/m365/sweeps/{sweep_id}  (parameter is the sweep id)
    petition_get = urlBase + "/accounts/" + val + "/m365/sweeps/" + parameter;
  } else if (key === "m365-findings") {
    // GET /accounts/{account_id}/m365/findings?status=...&severity=...
    petition_get = urlBase + "/accounts/" + val + "/m365/findings" + (parameter || "");
  } else if (key === "m365-finding-detail") {
    // GET /accounts/{account_id}/m365/findings/{finding_id}
    petition_get = urlBase + "/accounts/" + val + "/m365/findings/" + parameter;
  } else if (key === "m365-users") {
    // GET /accounts/{account_id}/m365/users?limit=...&offset=...
    petition_get = urlBase + "/accounts/" + val + "/m365/users" + (parameter || "");
  } else if (key === "m365-user-detail") {
    // GET /accounts/{account_id}/m365/users/{user_id}  (parameter is the Graph user_id or UPN)
    petition_get =
      urlBase +
      "/accounts/" +
      val +
      "/m365/users/" +
      encodeURIComponent(parameter || "");
  } else if (key === "m365-user-activity") {
    // GET /accounts/{account_id}/m365/users/{user_id}/activity?days=N
    // parameter can be either:
    //   - a bare user id / UPN string
    //   - { userId, days }
    const userIdPart =
      parameter && typeof parameter === "object" ? parameter.userId : parameter;
    const days =
      parameter && typeof parameter === "object" && parameter.days
        ? parameter.days
        : null;
    petition_get =
      urlBase +
      "/accounts/" +
      val +
      "/m365/users/" +
      encodeURIComponent(userIdPart || "") +
      "/activity" +
      (days ? `?days=${encodeURIComponent(days)}` : "");
  } else if (key === "m365-global-settings") {
    // GET /m365/global-settings
    petition_get = urlBase + "/m365/global-settings";
  } else if (key === "m365-global-cert") {
    // GET /m365/global-settings/cert
    petition_get = urlBase + "/m365/global-settings/cert";
  } else if (key === "gw-tenant") {
    // GET /accounts/{account_id}/google-workspace/tenant
    petition_get = urlBase + "/accounts/" + val + "/google-workspace/tenant";
  } else if (key === "gw-global-settings") {
    // GET /google_workspace/global-settings
    petition_get = urlBase + "/google_workspace/global-settings";
  } else if (key === "google-users") {
    // GET /accounts/{account_id}/google-workspace/users?max_results=...
    petition_get =
      urlBase + "/accounts/" + val + "/google-workspace/users" + (parameter || "");
  } else if (key === "google-user-detail") {
    // GET /accounts/{account_id}/google-workspace/users/{user_key}
    // parameter is the Google user key (id or primary email)
    petition_get =
      urlBase +
      "/accounts/" +
      val +
      "/google-workspace/users/" +
      encodeURIComponent(parameter || "");
  } else if (key === "google-groups") {
    // GET /accounts/{account_id}/google-workspace/groups?max_results=...
    petition_get =
      urlBase + "/accounts/" + val + "/google-workspace/groups" + (parameter || "");
  } else if (key === "google-group-members") {
    // GET /accounts/{account_id}/google-workspace/groups/{group_key}/members
    // parameter is the Google group key (id or email)
    petition_get =
      urlBase +
      "/accounts/" +
      val +
      "/google-workspace/groups/" +
      encodeURIComponent(parameter || "") +
      "/members";
  } else if (key === "voice360-sms-logs") {
    // GET /voice360-sms/logs?limit=...&offset=...&failures_only=...
    petition_get = urlBase + "/voice360-sms/logs" + (val || "");
  } else if (key === "appriver-global-config") {
    // GET /appriver/global-config
    petition_get = urlBase + "/appriver/global-config";
  } else if (key === "inbox") {
    // GET /crmui/crm/inbox — channel-agnostic recent inbound activity.
    // val is an optional query string like "?unread_only=true&limit=25"
    petition_get = urlBase + "/inbox" + (val || "");
  } else if (key === "inbox-count") {
    petition_get = urlBase + "/inbox/count";
  } else if (key === "inbox-thread") {
    // GET /crmui/crm/inbox/thread?source=&key= — every message in one
    // conversation. Kept out of the list response so opening three threads
    // does not mean downloading a hundred HTML emails.
    petition_get = urlBase + "/inbox/thread" + (val || "");
  } else if (key === "whatsapp-pending") {
    // Senders seen but not approved. Identity only, no message content.
    petition_get = urlBase + "/whatsapp/pending" + (val || "");
  } else if (key === "whatsapp-instances") {
    // GET /crmui/crm/whatsapp/instances — enrolled tech phones
    petition_get = urlBase + "/whatsapp/instances";
  } else if (key === "whatsapp-instance") {
    // val is the instance id; response includes live bridge state
    petition_get = urlBase + "/whatsapp/instances/" + val;
  } else if (key === "whatsapp-allowlist") {
    // val is an optional query string like "?instance_id=3"
    petition_get = urlBase + "/whatsapp/allowlist" + (val || "");
  } else if (key === "whatsapp-messages") {
    // val is an optional query string like "?triage_status=triaged&limit=50"
    petition_get = urlBase + "/whatsapp/messages" + (val || "");
  } else if (key === "whatsapp-thread") {
    // val is a message id; returns the surrounding conversation
    petition_get = urlBase + "/whatsapp/messages/" + val + "/thread";
  } else if (key === "vitelity-global-config") {
    // GET /vitelity/global-config
    petition_get = urlBase + "/vitelity/global-config";
  } else if (key === "vpn") {
    // GET /accounts/{account_id}/vpn - Managed VPN service + peer list
    petition_get = urlBase + "/accounts/" + val + "/vpn";
  } else if (key === "vpn-egress-ips") {
    // GET /accounts/{account_id}/vpn/egress-ips - Available shared/dedicated egress IPs
    petition_get = urlBase + "/accounts/" + val + "/vpn/egress-ips";
  } else if (key === "itppdf-service") {
    // GET /itppdf/services/{account_service_id} - ITP PDF seats + license keys + activations
    petition_get = urlBase + "/itppdf/services/" + val;
  } else if (key === "vpn-peer-config") {
    // GET /accounts/{account_id}/vpn/peers/{peer_id}/config - binary WireGuard config
    // val = { account_id, peer_id }
    petition_get = urlBase + "/accounts/" + val.account_id + "/vpn/peers/" + val.peer_id + "/config";
    return axios
      .get(petition_get, {
        headers: {
          Authorization: "Bearer " + token.authToken,
        },
        responseType: "blob",
      })
      .then((response) => response)
      .catch((error) => {
        console.error("API Error for", key, ":", error);
        throw error;
      });
  } else {
    petition_get = urlBase + "/" + key + "/" + val;
  }

  const headers = {
    Authorization: "Bearer " + token.authToken,
    ...(parameter?.headers || {}),
  };

  const axiosConfig = {
    url: petition_get,
    headers,
    params: parameter?.params,
    data: parameter?.data ?? parameter?.body,
  };

  const method = parameter?.method?.toUpperCase() || "GET";

  if (method === "GET") {
    return axios
      .get(petition_get, {
        headers,
        params: axiosConfig.params,
      })
      .then((response) => response)
      .catch((error) => {
        console.error("API Error for", key, ":", error);
        throw error;
      });
  }

  return axios
    .request({
      ...axiosConfig,
      method,
    })
    .then((response) => response)
    .catch((error) => {
      console.error("API Error for", key, ":", error);
      throw error;
    });
}
